import toast from 'react-hot-toast';

// react-hot-toast has no warning or info helpers, yet parts of the site call
// toast.warning() and toast.info(). Add them once, at start-up, so those calls
// show a message instead of throwing (FECOA-2174). CustomToast reads `tone`.
if (typeof toast.warning !== 'function') {
  toast.warning = (message, options = {}) => toast(message, { duration: 6000, ...options, tone: 'warning' });
}
if (typeof toast.info !== 'function') {
  toast.info = (message, options = {}) => toast(message, { ...options, tone: 'info' });
}

export default toast;
